import {TSMap} from "typescript-map";
import {BrandType} from "platform/enum/BrandType";

const MuiFonts: TSMap<BrandType, string[]> = new TSMap();
MuiFonts.set(BrandType.TradeApp, ["AvenirNext", "Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.Financika, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.FXGMZA, ["ComfortaaRegular", "Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.UBanker, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.SeventyTrades, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.A3Trading, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.TaoTrade, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.FXGM, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.GTCM, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.Fortissio, ["RobotoRegular", "Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.Ontega, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.ForexCT, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.TradoCenter, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.XLNTrade, ["Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.WBSmith, ["PoppinsRegular", "Roboto", "Arial", "sans-serif"]);
MuiFonts.set(BrandType.ToroInvest, ["PoppinsRegular", "Roboto", "Arial", "sans-serif"]);

export {
    MuiFonts
};
